import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/conference-system/webp/reinvox-elegant-2.webp")